export * from './current-user-header';

import { CurrentUserHeaderComponent } from './current-user-header';

export const LayoutMolecules = [
    CurrentUserHeaderComponent
]